<template>
	<div class="w-full">
		<h2 class="border-b text-2xl font-light md:text-4xl">Review</h2>

		<p class="mt-4 md:text-lg">Please verify that all information below is factual and current.</p>

		<section class="pl-2 md:pl-4">
			<div class="flex justify-between border-b pb-2 items-end mb-2 mt-6 -ml-2 md:-ml-4">
				<h3 class="m-0 p-0 text-2xl font-normal">Personal</h3>
				<button @click="$router.push('/personal')" class="bg-blue rounded py-1 px-2 text-white">Edit <span class="hidden sm:inline">Personal</span></button>
			</div>
			<p class="md:text-lg"><span class="font-semibold mr-1">Name:</span>{{ name }}</p>
			<p class="md:text-lg"><span class="font-semibold mr-1">Address:</span>{{ address }}</p>
			<p class="md:text-lg"><span class="font-semibold mr-1">Email:</span>{{ email }}</p>
			<p class="md:text-lg"><span class="font-semibold mr-1">Phone:</span>{{ phone }}</p>
		</section>

		<section class="pl-2 md:pl-4">	
			<div class="flex justify-between border-b pb-2 items-end mb-2 mt-6 -ml-2 md:-ml-4">
				<h3 class="m-0 p-0 text-2xl font-normal">Questionnaire</h3>
				<button @click="$router.push('/questionnaire')" class="bg-blue rounded py-1 px-2 text-white">Edit <span class="hidden sm:inline">Questionnaire</span></button>
			</div>
			<p class="mt-2 md:text-lg">I <span class="font-bold uppercase">{{ legally }}</span> be legally employed in this country.</p>
			<p class="mt-2 md:text-lg">I <span class="font-bold uppercase">{{ nights }}</span> work nights and weekends.</p>
		</section>

		<section class="pl-2 md:pl-4">	
			<div class="flex justify-between border-b pb-2 items-end mb-2 mt-6 -ml-2 md:-ml-4">
				<h3 class="m-0 p-0 text-2xl font-normal">Experience</h3>
				<button @click="$router.push('/experience')" class="bg-blue rounded py-1 px-2 text-white">Edit <span class="hidden sm:inline">Experience</span></button>
			</div>

			<div v-for="(school, index) in education" :key="`school-${index}`" class="mb-4">
				<h4 class="md:text-xl font-normal">Education #{{ index + 1 }}</h4>
				<div class="pl-2 md:pl-4">
					<p class="md:text-lg"><span class="font-semibold mr-1">Type:</span>{{ school.type }}</p>
					<p class="md:text-lg"><span class="font-semibold mr-1">Name:</span>{{ school.name }}</p>
					<p class="md:text-lg"><span class="font-semibold mr-1">Location:</span>{{ school.city }}, {{ school.state }}</p>
					<p class="md:text-lg"><span class="font-semibold mr-1">Years Attended:</span>{{ school.years }} years</p>
					<p v-if="school.field" class="md:text-lg"><span class="font-semibold mr-1">Field of Study:</span>{{ school.field }}</p>
				</div>
			</div>

			<div v-for="(employer, index) in employment" :key="`employer-${index}`" class="mb-4">
				<h4 class="md:text-xl font-normal">Employer #{{ index + 1 }}</h4>
				<div class="pl-2 md:pl-4">
					<p class="md:text-lg"><span class="font-semibold mr-1">Name:</span>{{ employer.name }}</p>
					<p class="md:text-lg"><span class="font-semibold mr-1">Location:</span>{{ employer.city }}, {{ employer.state }}</p>
					<p class="md:text-lg"><span class="font-semibold mr-1">Duration:</span>{{ employer.start }} - {{ employer.end }}</p>
					<p class="md:text-lg"><span class="font-semibold mr-1">Responsibilities:</span>{{ employer.responsibilities }}</p>
					<p class="md:text-lg"><span class="font-semibold mr-1">Reason For Leaving:</span>{{ employer.reason }}</p>
				</div>
			</div>
		</section>

		<p v-if="submissionError" class="bg-red-lightest text-lg border-2 border-red-dark text-red-darkest py-2 px-4 text-center">There was an issue with your submission.<br class="hidden sm:inline-block"> Please try again later.</p>

		<div class="mt-4 flex text-lg justify-between">

			<button @click="submit" :class="{ 'loading': submitting }" class="ml-auto font-semibold bg-green-dark text-white py-2 px-4 rounded ml-4 block">Submit</button>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import formurlencoded from 'form-urlencoded';
	import { parsePhoneNumberFromString } from 'libphonenumber-js'

	export default {
		computed: {
			personal() {
				return this.$store.state.form.personal
			},

			questionnaire() {
				return this.$store.state.form.questionnaire
			},

			experience() {
				return this.$store.state.form.experience
			},

			name() {
				return [
					this.personal.first,
					this.personal.middle,
					this.personal.last,
				].filter(value => {
					return value !== ''
				}).join(' ')
			},

			address() {
				return [
					this.personal.address1,
					this.personal.address2,
					`${this.personal.city}, ${this.personal.state} ${this.personal.zip}`
				].filter(value => {
					return value !== ''
				}).join(' ')
			},

			email() {
				return this.personal.email
			},

			phone() {
				return parsePhoneNumberFromString(this.personal.phone, 'US').formatNational()
			},

			legally() {
				return this.questionnaire.legally ? 'can' : 'can not'
			},

			nights() {
				return this.questionnaire.nights ? 'can' : 'can not'
			},

			education() {
				return this.experience.education
			},

			employment() {
				return this.experience.employment
			},
		},


		data() {
			return {
				submitting: false,

				submissionError: false,
			}
		},

		methods: {
			submit() {
				this.submitting = true

				const data = {
					'form-name': this.$store.state.position.replace(/\s/g, '-').toLowerCase(),
					honey: '',

					name: this.name,
					address: this.address,
					email: this.email,
					phone: this.phone,

					legally: this.questionnaire.legally ? 'I CAN be legally employed in this country' : 'I CAN NOT be legally employed in this country',
					nights: this.questionnaire.nights ? 'I CAN work nights and weekends' : 'I CAN NOT work nights and weekends',

					education: this.education.map((school, index) => {
						return `
							Education #${index + 1}
							Type: ${school.type}
							Name: ${school.name}
							Location: ${school.city}, ${school.state}
							Years Attended: ${school.years}
							Field of Study: ${school.field}
						`.trim().replace(/[\t]/g, '')
					}).join('\r\n\r\n'),

					employment: this.employment.map((employer, index) => {
						return `
							Employer #${index + 1}
							Name: ${ employer.name }
							Location: ${employer.city}, ${employer.state}
							Duration: ${employer.start} - ${employer.end}
							Responsibilities: ${employer.responsibilities}
							Reason for Leaving: ${employer.reason}
						`.trim().replace(/[\t]/g, '')
					}).join('\r\n\r\n'),
				}

				axios.post('/thanks', formurlencoded(data)).then(() => {
					this.$store.commit('submit')
					this.$router.push('/thanks')
				}).catch(() => {
					this.submissionError = true
					this.submitting = false
				})

			}
		},
	}
</script>
